module.exports = __webpack_public_path__ + "comp-offers-sprite.283a8d61f588e59dd5be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portal/comp-offers-sprite.png
// module id = 14
// module chunks = 10